import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMobileAlt,
  faTv,
  faLightbulb,
  faGift,
} from "@fortawesome/free-solid-svg-icons";

const Services = () => {
  const services = [
    {
      icon: faMobileAlt,
      title: "Mobile Recharge",
      description: "Prepaid & Postpaid recharge for all operators",
    },
    {
      icon: faTv,
      title: "DTH Recharge",
      description: "Recharge for all DTH providers",
    },
    {
      icon: faLightbulb,
      title: "Bill Payments",
      description: "Electricity, Gas, Water and other utility bills",
    },
    {
      icon: faGift,
      title: "Gift Vouchers",
      description: "Purchase gift cards and vouchers",
    },
  ];

  return (
    <section id="services" className="services">
      <div className="container">
        <h2>Our Services</h2>
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <FontAwesomeIcon icon={service.icon} size="3x" />
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
